export default "__VITE_ASSET__f0d43b4a__"